// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-e1b4da68]{display:flex}.header H1[data-v-e1b4da68]{flex:1}", ""]);
// Exports
module.exports = exports;
